import { debounce } from 'lodash-es';

document
  .querySelectorAll('[data-scroll-spy-controller]')
  .forEach((controller) => {
    const selector = controller.dataset.spySelector || 'a';
    const spyActiveClass = controller.dataset.spyActiveClass || 'active';

    const navItems = {};
    const sections = [];
    controller.querySelectorAll(selector).forEach((spyEl) => {
      const id = spyEl.dataset.spyId;
      navItems[id] = spyEl;
      const section = document.getElementById(id);
      if (section) {
        sections.push(section);
      } else {
        console.debug('count not find section for id', id);
      }
    });

    const pixelStringToInteger = (string) =>
      parseInt(string.replace('px', ''), 10);

    // set scroll padding on html element if it's not there
    const setHTMLScrollPadding = () => {
      const style = getComputedStyle(document.body).scrollPaddingTop;
      if (style !== 'auto') {
        document.documentElement.style.scrollPaddingTop = style;
      }
    };

    setHTMLScrollPadding();

    const bodyScrollPaddingTop = () => {
      const style = getComputedStyle(document.body).scrollPaddingTop;
      if (style === 'auto') {
        return 0;
      } else {
        return pixelStringToInteger(style) - 10;
      }
    };

    const scrollPosition = () => {
      const topOffset = window.scrollY + bodyScrollPaddingTop();
      const bottomOffset = topOffset + window.innerHeight;
      return {
        topOffset,
        bottomOffset,
      };
    };

    const topInView = (el, pos) => {
      return el.offsetTop > pos.topOffset && el.offsetTop < pos.bottomOffset;
    };
    // This is the case where the element spans the full viewport
    const coversView = (el, pos) =>
      el.offsetTop < pos.topOffset &&
      el.offsetTop + el.offsetHeight > pos.bottomOffset;

    const scrollNavItemIfNeeded = (navItem) => {
      const scrollableContainer = navItem.parentElement;
      const containerVisibleSize = scrollableContainer.offsetWidth;
      const containerFullSize = scrollableContainer.scrollWidth;
      const maxScrollLeft = containerFullSize - containerVisibleSize;
      const minScrollLeft = 0;

      // TODO: work on a smart padding value

      const paddingValue = pixelStringToInteger(
        getComputedStyle(scrollableContainer).paddingRight,
      );
      // check if we have horizontal scrolling
      if (containerVisibleSize < containerFullSize) {
        const navItemRightOffset = navItem.offsetWidth + navItem.offsetLeft;

        // check if the new nav item is past the visible container on the right, if so we add to scrollLeft of container
        if (navItemRightOffset > containerVisibleSize) {
          scrollableContainer.scrollLeft = Math.max(
            navItem.offsetWidth + paddingValue,
            maxScrollLeft,
          );
          // check if the new nav item is too far left and we've already scrolled right, if so we subtract from the scrollLeft of container
        } else if (navItem.offsetLeft < scrollableContainer.scrollLeft) {
          scrollableContainer.scrollLeft = Math.max(
            navItem.offsetLeft - paddingValue,
            minScrollLeft,
          );
        }
      }
    };

    const activateItem = (section) => {
      let navItem;
      if (section) {
        navItem = navItems[section.id];
        navItem.classList.add(spyActiveClass);
        scrollNavItemIfNeeded(navItem);
      }
      // remove 'active' class from any navItem that is not
      // same as 'navItem' defined above
      Object.values(navItems).forEach((item) => {
        if (item !== navItem) {
          item.classList.remove(spyActiveClass);
        }
      });
    };

    let lastScroll = window.scrollY;
    const handleScroll = () => {
      if (Math.abs(window.scrollY - lastScroll) < 10) {
        return;
      }
      lastScroll = window.scrollY;
      const pos = scrollPosition();
      for (const section of sections) {
        if (topInView(section, pos) || coversView(section, pos)) {
          activateItem(section);
          return;
        }
      }
    };

    handleScroll();

    window.addEventListener('scroll', debounce(handleScroll, 50), {
      passive: true,
    });
  });
